module.exports = __webpack_public_path__ + "static/try-bg-70c1ffeed1f0c05d8db1801e23abb817.png";